import useReturnForFreeSaleAvailability from 'hooks/CharterFlights/useReturnForFreeSaleAvailability'
import { useRewardSeatsEnabled } from 'hooks/Flights/useRewardSeatsEnabled'
import MaldivesCharterBuyPointsBanner from './MaldivesCharterBuyPointsBanner'
import MaldivesCharterReturnForFreeCalendarBanner from './MaldivesCharterReturnForFreeCalendarBanner'

interface Props {
  flush?: boolean
}

function MaldivesCharterCalendarBanner({ flush = false }: Props) {
  const { isSaleVisible } = useReturnForFreeSaleAvailability()
  const isRewardSeatsEnabled = useRewardSeatsEnabled()

  if (isSaleVisible) {
    return <MaldivesCharterReturnForFreeCalendarBanner flush={flush} />
  }

  if (isRewardSeatsEnabled) {
    return <MaldivesCharterBuyPointsBanner flush={flush} />
  }

  return null
}

export default MaldivesCharterCalendarBanner
